export default __webpack_public_path__ + "static/media/kn_IN.65a842ed.svg";